import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

function getTags(row: FulfillmentGroupData): string[] {
  const allTags = new Set<string>();

  if (row.items) {
    for (const item of row.items) {
      if (item.productTags) {
        for (const tag of item.productTags) {
          allTags.add(tag);
        }
      }
    }
  }

  return Array.from(allTags);
}

export const ProductTagsCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Product tags",
    cell: (row) => {
      const renderedTags = getTags(row);
      return renderedTags.join(",");
    },
    expandedCsvCell: (row, expansionIndex) => {
      const productTags =
        getExpandedItems(row)?.[expansionIndex]?.productTags ?? [];
      return productTags.join(",");
    },
  };
